export default __webpack_public_path__ + "static/media/sidebar7.500588c3.jpg";